import profileUser from '@/screens/profileUser/List'
import auth from './middleware/auth'

export default [
  {
    path: '/profile-user',
    component: profileUser,
    name: 'Profile user',
    meta: {
      requireAuth: true,
      permissions: ['manager', 'buyer', 'provider'],
      middleware: { auth }
    }
  }
]
